<script setup lang="ts">

import Restart from '@material-symbols/svg-400/rounded/replay.svg'

function onClick() {
  window.location.reload();
}

</script>
<template>
  <div class="p-8 text-center dark:text-gray-300">
    <p class="text-xl">Thank you!</p>
    <br />
    <p>Your testkit is now registered, please check back soon to find out your test result.</p>
    <br />
    <div class="flex justify-center my-4 text-sm">
      <button @click="onClick" class="btn-next py-2 px-4">
        Register another TestKit
        <Restart class="w-4 h-4 ml-2" />
      </button>
    </div>
  </div>
</template>
